module.exports = __webpack_public_path__ + "img/ic_pencil.307df3ca.svg";